import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import { Link } from 'react-router-dom';
import { translate } from 'admin-on-rest';
import { stringify } from 'query-string';

const LinkToRelatedAccounts = ({ record, translate }) => (
    <FlatButton
        primary
        label="Accounts"
        containerElement={<Link
            to={{
                pathname: '/accounts',
                search: stringify({ page: 1, perPage: 25, filter: JSON.stringify({ bank: record.id, time: 'current_month' }) }),
            }}
        />}
    />
);

export default translate(LinkToRelatedAccounts);



// WEBPACK FOOTER //
// ./src/Banks/LinkToRelatedAccounts.js